import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=0584ef9c"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"
import style0 from "./Others.vue?vue&type=style&index=0&id=0584ef9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports